import { useMutation } from '@tanstack/react-query';
import { ValidationRuleFormDataSchema } from '../schema/ValidationRuleFormDataSchema';
import { apiClient, ApiErrorResponse } from '../../common/ApiClient';
import { DataObjectDescriptionVersionUrl } from './DataObjectDescriptionVersionUrl';
import { RcFile } from 'antd/es/upload';
import { ValidationRuleFormDataType } from '../schema';
import { expand } from 'uri-template-lite';

interface IArgs {
  file: string | Blob | RcFile;
  id?: number;
}

export const useMutateValidationRulesUpload = (
  onProgress?: (progress: number) => void,
) =>
  useMutation<ValidationRuleFormDataType[], ApiErrorResponse, IArgs>({
    mutationKey: ['validationRulesUpload'],
    mutationFn: async ({ file, id }) =>
      apiClient
        .post(
          expand(DataObjectDescriptionVersionUrl.uploadRules, { id }),
          {
            file,
          },
          {
            headers: { 'content-type': 'multipart/form-data' },
            onUploadProgress: (progress) => {
              if (!progress.total) {
                return;
              }
              onProgress?.((progress.loaded / progress.total) * 100);
            },
          },
        )
        .then((response) =>
          ValidationRuleFormDataSchema.array().parse(response.data),
        ),
  });
